export default __webpack_public_path__ + "static/media/ikara-logo-header.6ee46afe.png";